import {createSlice} from "@reduxjs/toolkit";

export const loadingSlice = createSlice({
    name: "loadingDetails",
    initialState: {
        loading: {},
    },
    reducers: {
        setLoading(state, action){
            state.dashboardDataByprojId = action.payload;
        },
    }
})

export const {setLoading} = loadingSlice.actions;